import { useAuth } from 'app/provider/auth'
import { ModeratedGroupsScreen } from './moderated-groups-screen'
import {
  useModeratedUserGroupsQuery,
  userModeratedGroupsQuery,
} from '../../queries'
import { useState } from 'react'

export interface ModeratedGroupsScreenContainerProps {
  HeaderComponent?: React.ReactNode
}

export const ModeratedGroupsScreenContainer = (props: ModeratedGroupsScreenContainerProps) => {
  const { user } = useAuth()
  const [refreshing, setRefreshing] = useState(false)

  const {
    data: userGroupsData,
    refetch: refetchUserGroups,
    networkStatus: userGroupsNetworkStatus,
  } = useModeratedUserGroupsQuery({
    variables: {
      ...userModeratedGroupsQuery.defaultVariables,
    },
    skip: !user,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  })

  const handlePullToRefresh = async () => {
    setRefreshing(true)
    await Promise.all([refetchUserGroups()])
    setRefreshing(false)
  }

  const userModeratedGroups = userGroupsData?.userModeratedGroups?.docs || []


  return (
    <ModeratedGroupsScreen
      HeaderComponent={props.HeaderComponent}
      userModeratedGroups={userModeratedGroups}
      userModeratedGroupsLoading={userGroupsNetworkStatus === 1}
      user={user}
      refreshing={refreshing}
      onPullToRefresh={handlePullToRefresh}
    />
  )
}
